export default __webpack_public_path__ + "static/media/Vestment of the Revelations.ad21e5e1.jpg";